// extracted by mini-css-extract-plugin
export default {"loadingText":"YRLW_K","dot":"FhnC5Y","aiPlanTitleSkeletonWave":"v8wcdu","dots":"eX41ie"};